import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Tag } from 'antd/lib';
import { Link } from 'react-router-dom';

import * as Icons from '@ant-design/icons';

import { graphql } from 'react-apollo';

import escudo from '../../assets/imagenes/escudo.svg';

import Loading from './Loading';
import getUsuario from '../../graphql/querys/auth/getUsuario.graphql';

import { compose } from 'redux';

import { logout } from '../../actions/keycloak.js';

import {
  FaVenusMars,
  FaFileAlt,
  FaUser,
  FaBuilding,
  FaUsers,
  FaUnlockAlt,
  FaBalanceScale,
} from 'react-icons/fa';
import { connect } from 'react-redux';

const SubMenu = Menu.SubMenu;

@graphql(getUsuario)
class MenuPropio extends React.Component {
  logout = () => {
    const { authenticator } = this.props;
    this.props.logout();
    authenticator.keycloak.logout();
  };

  render() {
    const { data } = this.props;
    if (data.loading) {
      return <Loading />;
    }

    if (!data.getUsuario) {
      return null;
    }

    const urlOV =
      this.props.environment === 'production'
        ? 'https://auth2.jusneuquen.gov.ar/realms/production/protocol/openid-connect/auth?client_id=ov&redirect_uri=https://ov.jusneuquen.gov.ar&response_type=code'
        : 'https://auth2.jusneuquen.gov.ar/realms/staging/protocol/openid-connect/auth?client_id=ov&redirect_uri=https://test.jusneuquen.gov.ar&response_type=code';


        const urlBEBusFed = 
        this.props.environment === 'production'
          ? 'https://busin.jusneuquen.gov.ar/'
          : 'https://auth2.jusneuquen.gov.ar/realms/staging/protocol/openid-connect/auth?client_id=bandeja-entrada-bus-federal&redirect_uri=http%3A%2F%2F172.21.1.119%3A9001%2Fbe-bus-federal';

          
    const background =
      this.props.environment === 'staging' ||
      this.props.environment === 'develop'
        ? '#804000'
        : 'inherith';
    let estilo = {
      width: '100%',
      display: 'inline-flex',
      height: 64,
    };

    let modo = 'horizontal';
    let ancho = screen.width;
    // console.log('ANCHO: ', ancho);
    // if (screen.width >= 1280) {
    //   estilo = { width: '100%', display: 'inline-flex' };
    //   modo = 'horizontal';
    // } else {
    //   estilo = { width: '100%' };
    //   modo = 'inline';
    // }

    let usuario = data.getUsuario;

    return (
      <div style={estilo}>
        <div className="escudo-header">
          <Link to="/">
            <img alt="Logo Poder Judicial de Neuquén" src={escudo} />
          </Link>
        </div>
        <div className="logo">
          <Link to="/">
            <p style={{ width: 70 }}>SIJUP</p>
          </Link>
        </div>

        <Menu
          theme="dark"
          mode={modo}
          // defaultSelectedKeys={["2"]}
          style={{
            lineHeight: '64px',
            width: '100%',
            backgroundColor: background,
          }}
        >
          {usuario.rol === 'SUELDOS' ? (
            <>
              <SubMenu
                key="certificacionesRolSueldos"
                title={
                  <span>
                    <Icons.FileTextOutlined />
                    <span className="nav-text">Certificaciones Traspasos</span>
                  </span>
                }
              >
                <Menu.Item key="/rrhh/certificacionesTraspaso">
                  <Link to="/rrhh/certificacionesTraspaso">
                    <Icons.FileTextOutlined />
                    <span className="nav-text">Certificaciones</span>
                  </Link>
                </Menu.Item>
              </SubMenu>
              <SubMenu
                key="usuario"
                style={{ float: 'right' }}
                title={
                  <span>
                    <FaUser />
                    {ancho >= 1280 && <span> {data.getUsuario.username}</span>}
                  </span>
                }
              >
                <Menu.Item key="salir">
                  <a onClick={() => this.logout()}>Salir</a>
                </Menu.Item>
              </SubMenu>
              <SubMenu
                key="dghSueldos"
                title={
                  <span>
                    <FaUsers />
                    {ancho >= 1280 && <span> DGH</span>}
                  </span>
                }
              >
                <SubMenu
                  key="novedadesSueldos"
                  title={
                    <span>
                      <Icons.FolderOpenOutlined />
                      <span className="nav-text">Novedades</span>
                    </span>
                  }
                >
                  <Menu.Item key="verNovedadesSueldos">
                    <Link to="/rrhh/novedades/">
                      <Icons.TableOutlined />
                      <span className="nav-text">Ver Novedades</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>
              </SubMenu>
              <SubMenu
                key="tag"
                style={{ float: 'right' }}
                title={
                  <Tag color="white" style={{ color: 'rgb(2, 15, 31)' }}>
                    {usuario && usuario.organismo
                      ? usuario.organismo.nombre
                      : 'SIN ORGANISMO'}
                  </Tag>
                }
              />
            </>
          ) : (
            // >>>>>>>>>AQUI EMPIEZA EL MENU PARA USUARIOS SIJUP<<<<<<<<<
            <>
              <SubMenu
                key="tramites"
                title={
                  <span>
                    <FaFileAlt />
                    {ancho >= 1280 && <span> Tramites</span>}
                  </span>
                }
              >
                {/* <Menu.Item key="crear">
              <Link to="/formularios">Ir Prueba</Link>
            </Menu.Item> */}

                <SubMenu
                  key="personas"
                  title={
                    <span>
                      <Icons.TeamOutlined />
                      <span className="nav-text">Personas</span>
                    </span>
                  }
                >
                  <Menu.Item key="/personas/actualizar">
                    <Link to="/tramites/personas/actualizar">
                      <Icons.TeamOutlined />
                      <span className="nav-text">Personas</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="/antecedentes">
                    <Link to="/tramites/personas/antecedentes">
                      <Icons.SearchOutlined />
                      <span className="nav-text">Antecedentes</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>

                {/* <Menu.Item key="venderSello">
              <Link to="/tramites/sellos/vender">
                <Icons.TagsOutlined />
                <span className="nav-text">Vender Tasa </span>
              </Link>
            </Menu.Item> */}

                <Menu.Item key="/atencion/crear">
                  <Link to="/tramites/atencion/crear">
                    <Icons.FileTextOutlined />
                    <span className="nav-text">Atenciones</span>
                  </Link>
                </Menu.Item>

                <Menu.Item key="certificacion/crear">
                  <Link to="/tramites/certificacion/crear">
                    <Icons.FileTextOutlined />
                    <span className="nav-text">Certificaciones</span>
                  </Link>
                </Menu.Item>

                <Menu.Item key="acreditacion/crear">
                  <Link to="/tramites/acreditacion/crear">
                    <Icons.FileTextOutlined />
                    <span className="nav-text">Acreditaciones</span>
                  </Link>
                </Menu.Item>

                <Menu.Item key="declaracion/crear">
                  <Link to="/tramites/declaracion/crear">
                    <Icons.FileTextOutlined />
                    <span className="nav-text">Declaracion Jurada</span>
                  </Link>
                </Menu.Item>

                <Menu.Item key="informacionSumaria/crear">
                  <Link to="/tramites/informacionSumaria/crear">
                    <Icons.FileTextOutlined />
                    <span className="nav-text">Informacion Sumaria</span>
                  </Link>
                </Menu.Item>

                <Menu.Item key="registrosEntradasSalidas/crear">
                  <Link to="/tramites/registrosEntradasSalidas/crear">
                    <Icons.FileTextOutlined />
                    <span className="nav-text">Registro E/S</span>
                  </Link>
                </Menu.Item>

                <SubMenu
                  key="autorizaciones"
                  title={
                    <span>
                      <Icons.FolderOpenOutlined />
                      <span className="nav-text">Autorizaciones</span>
                    </span>
                  }
                >
                  {/*  <Menu.Item key="autorizaciones/viaje">
                <Link to="/tramites/autorizacion/viaje/crear">
                  <Icons.FileTextOutlined />
                  <span className="nav-text"> Viaje Menores</span>
                </Link>
              </Menu.Item> */}
                  <Menu.Item key="autorizaciones/menores">
                    <Link to="/tramites/autorizacion/menor/crear">
                      <Icons.FileTextOutlined />
                      <span className="nav-text">Viaje Menores</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="autorizaciones/trabajoMenores">
                    <Link to="/tramites/autorizacion/trabajomenor/crear">
                      <Icons.FileTextOutlined />
                      <span className="nav-text">Trabajo Adolescente</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="autorizaciones/ptras">
                    <Link to="/tramites/autorizacion/otras/crear">
                      <Icons.FileTextOutlined />
                      <span className="nav-text">Otras</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <SubMenu
                  key="documentosIndepentiendes"
                  title={
                    <span>
                      <Icons.FolderOpenOutlined />
                      <span className="nav-text">Docs. Indept.</span>
                    </span>
                  }
                >
                  <Menu.Item key="oficios/nuevo">
                    <Link to="/tramites/oficios/nuevo/">
                      <Icons.FileTextOutlined />
                      <span className="nav-text">Nuevo Documento</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="oficios/listar">
                    <Link to="/admin/oficios">
                      <Icons.FileTextOutlined />
                      <span className="nav-text">Listar Documentos </span>
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <SubMenu
                  key="acuerdosExtrajudiciales"
                  title={
                    <span>
                      <Icons.TeamOutlined />
                      <span className="nav-text">Acuerdos Extrajudiciales</span>
                    </span>
                  }
                >
                  <Menu.Item key="crearAcuerdo">
                    <Link to="/tramites/acuerdosExtrajudiciales/crear">
                      <Icons.TeamOutlined />
                      <span className="nav-text">Generar Acuerdo</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="listarAcuerdos">
                    <Link to="/tramites/acuerdosExtrajudiciales/listar">
                      <Icons.SearchOutlined />
                      <span className="nav-text">Listar Acuerdos</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <SubMenu
                  key="administracion/tramites"
                  title={
                    <span>
                      <Icons.FolderOpenOutlined />
                      <span className="nav-text">Reportes</span>
                    </span>
                  }
                >
                  <Menu.Item key="administracion/atenciones">
                    <Link to="/admin/atenciones">
                      <Icons.TableOutlined />
                      <span className="nav-text">Atenciones</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="administracion/certificaciones">
                    <Link to="/admin/certificaciones">
                      <Icons.TableOutlined />
                      <span className="nav-text">Certificaciones</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="administracion/acreditaciones">
                    <Link to="/admin/acreditaciones">
                      <Icons.TableOutlined />
                      <span className="nav-text">Acreditaciones</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="administracion/declaraciones">
                    <Link to="/admin/declaraciones">
                      <Icons.TableOutlined />
                      <span className="nav-text">Declaraciones Juradas</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="administracion/informacionesSumarias">
                    <Link to="/admin/informacionesSumarias">
                      <Icons.TableOutlined />
                      <span className="nav-text">Informaciones Sumarias</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="administracion/autorizacion_viajes">
                    <Link to="/admin/autorizaciones_viajes">
                      <Icons.TableOutlined />
                      <span className="nav-text">Autorizacion Menor Viaje</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="administracion/autorizacion_trabajo_menor">
                    <Link to="/admin/autorizaciones_trabajo_menor">
                      <Icons.TableOutlined />
                      <span className="nav-text">Autorizacion Trabajo Adolescente</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="administracion/autorizacion_otras">
                    <Link to="/admin/autorizaciones_otras">
                      <Icons.TableOutlined />
                      <span className="nav-text">Otras Autorizaciones</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="administracion/registrosEntradasSalidas">
                    <Link to="/admin/registrosEntradasSalidas">
                      <Icons.TableOutlined />
                      <span className="nav-text">Registros E/S</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <Menu.Item key="/urlExterna">
                  <a
                    href="http://200.41.238.182/sisrpi/latest/login.php"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icons.LinkOutlined />
                    <span className="nav-text">Protección de la Vivienda</span>
                  </a>
                </Menu.Item>
              </SubMenu>

              <SubMenu
                key="Contravenciones"
                title={
                  <span>
                    <FaBalanceScale />
                    {ancho >= 1280 && (
                      <span className="nav-text"> Expedientes</span>
                    )}
                  </span>
                }
              >
                <Menu.Item key="crear">
                  <Link to="/contravenciones/expedientes/nuevo">
                    <Icons.SwitcherOutlined />
                    <span className="nav-text">Generar Expediente</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="listar">
                  <Link to="/contravenciones/expedientes">
                    <Icons.SearchOutlined />
                    <span className="nav-text">Listar Expedientes</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="buscar">
                  <Link to="/contravenciones/buscarExpedientes">
                    <Icons.SearchOutlined />
                    <span className="nav-text">Buscar Expedientes</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="buscarPorCodigo">
                  <Link to="/contravenciones/buscarPorCodigo">
                    <Icons.SearchOutlined />
                    <span className="nav-text">Codigo de Barras</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="estadisticasExpedientes">
                  <Link to="/contravenciones/estadisticias">
                    <Icons.SearchOutlined />
                    <span className="nav-text">Estadisticas</span>
                  </Link>
                </Menu.Item>
              </SubMenu>

              <SubMenu
                key="ViolenciaGenero"
                title={
                  <span>
                    <FaVenusMars />
                    {ancho >= 1280 && <span> Violencia</span>}
                  </span>
                }
              >
                <Menu.Item key="evaluarSituacion">
                  {usuario.organismo.conectaOV ? (
                    <a href={urlOV} target="_blank" rel="noopener noreferrer">
                      <Icons.TeamOutlined />
                      <span className="nav-text">Generar Caso</span>
                    </a>
                  ) : (
                    <Link to="/violenciaGenero/evaluarCaso">
                      <Icons.TeamOutlined />
                      <span className="nav-text">Generar Caso</span>
                    </Link>
                  )}
                </Menu.Item>
                {usuario.organismo.conectaOV ? (
                  <SubMenu
                    key="listarCasos"
                    title={
                      <span>
                        <Icons.TeamOutlined />
                        <span className="nav-text">Listar Casos</span>
                      </span>
                    }
                  >
                    <Menu.Item key="listarCasosSijup">
                      <Link to="/violenciaGenero/listarCasos">
                        <Icons.SearchOutlined />
                        <span className="nav-text">Listar Casos SIJUP</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="listarCasosOV">
                      <a href={urlOV} target="_blank" rel="noopener noreferrer">
                        <Icons.SearchOutlined />
                        <span className="nav-text">Listar Casos OV</span>
                      </a>
                    </Menu.Item>
                  </SubMenu>
                ) : (
                  <Menu.Item key="listarCasosSijup">
                    <Link to="/violenciaGenero/listarCasos">
                      <Icons.SearchOutlined />
                      <span className="nav-text">Listar Casos</span>
                    </Link>
                  </Menu.Item>
                )}

                <Menu.Item key="reporteCasos">
                  <Link to="/violenciaGenero/reporteCasos">
                    <Icons.FileTextOutlined />
                    <span className="nav-text">Reporte de Casos</span>
                  </Link>
                </Menu.Item>
              </SubMenu>

              <SubMenu
                key="Sellos"
                title={
                  <span>
                    <FaBuilding />
                    {ancho >= 1280 && <span> AG</span>}
                  </span>
                }
              >
                <SubMenu
                  key="TasasMenu"
                  title={
                    <span>
                      <Icons.FolderOpenOutlined />
                      <span className="nav-text">Tasas</span>
                    </span>
                  }
                >
                  <SubMenu
                    key="depositos"
                    title={
                      <span>
                        <Icons.FileTextOutlined />
                        <span className="nav-text">Depositos</span>
                      </span>
                    }
                  >
                    <Menu.Item key="nuevoDeposito">
                      <Link to="/administracionGeneral/depositos/nuevo">
                        <Icons.TagsOutlined />
                        <span className="nav-text">Nuevo Deposito</span>
                      </Link>
                    </Menu.Item>
                  </SubMenu>

                  <SubMenu
                    key="reportes_sellos"
                    title={
                      <span>
                        <Icons.FileTextOutlined />
                        <span className="nav-text">Reportes</span>
                      </span>
                    }
                  >
                    <Menu.Item key="sellos/reportes/ventasporfecha">
                      <Link to="/administracionGeneral/sellos/reportes/ventasporfecha">
                        <Icons.FileTextOutlined />
                        <span className="nav-text">Ventas por Fecha</span>
                      </Link>
                    </Menu.Item>

                    <Menu.Item key="sellos/reportes/ventas">
                      <Link to="/administracionGeneral/sellos/reportes/ventas">
                        <Icons.FileTextOutlined />
                        <span className="nav-text">Detalle de Ventas</span>
                      </Link>
                    </Menu.Item>

                    <Menu.Item key="depositos/reportes/depositosporfecha">
                      <Link to="/administracionGeneral/depositos/reportes/depositosporfecha">
                        <Icons.FileTextOutlined />
                        <span className="nav-text">Depositos por Fecha</span>
                      </Link>
                    </Menu.Item>

                    <SubMenu
                      key="rendiciones"
                      title={
                        <span>
                          <Icons.FolderOpenOutlined />
                          <span className="nav-text">Rendiciones</span>
                        </span>
                      }
                    >
                      <Menu.Item key="reportes/rendicion/generar">
                        <Link to="/administracionGeneral/reportes/rendicion/generar">
                          <Icons.FileTextOutlined />
                          <span className="nav-text">Nueva Rendicion</span>
                        </Link>
                      </Menu.Item>

                      <Menu.Item key="reportes/rendicion/ver">
                        <Link to="/administracionGeneral/reportes/rendicion/ver">
                          <Icons.FileTextOutlined />
                          <span className="nav-text">Listar Rendiciones</span>
                        </Link>
                      </Menu.Item>
                    </SubMenu>
                  </SubMenu>
                </SubMenu>

                <SubMenu
                  key="ContravencionesMenu"
                  title={
                    <span>
                      <Icons.FolderOpenOutlined />
                      <span className="nav-text">Contravenciones</span>
                    </span>
                  }
                >
                  <SubMenu
                    key="depositosContravenciones"
                    title={
                      <span>
                        <Icons.FileTextOutlined />
                        <span className="nav-text">Depositos</span>
                      </span>
                    }
                  >
                    <Menu.Item key="nuevoDepositoContravenciones">
                      <Link to="/administracionGeneral/depositosContravenciones/nuevo">
                        <Icons.TagsOutlined />
                        <span className="nav-text">
                          Nuevo Deposito Contravencion
                        </span>
                      </Link>
                    </Menu.Item>

                    <Menu.Item key="verDepositosContravencion">
                      <Link to="/administracionGeneral/depositosContravencion">
                        <Icons.TagsOutlined />
                        <span className="nav-text">
                          Ver Deposito Contravencion
                        </span>
                      </Link>
                    </Menu.Item>
                  </SubMenu>

                  <SubMenu
                    key="recibosContravenciones"
                    title={
                      <span>
                        <Icons.FileTextOutlined />
                        <span className="nav-text">Recibos</span>
                      </span>
                    }
                  >
                    <Menu.Item key="reporteRecibos">
                      <Link to="/administracionGeneral/recibosContravencion">
                        <Icons.TagsOutlined />
                        <span className="nav-text">Reporte Recibos</span>
                      </Link>
                    </Menu.Item>
                  </SubMenu>
                </SubMenu>

                <Menu.Item key="agh/configuracion">
                  <Link to="/administracionGeneral/configuracion">
                    <Icons.FileTextOutlined />
                    <span className="nav-text">Configuracion</span>
                  </Link>
                </Menu.Item>
              </SubMenu>

              <SubMenu
                key="dgh"
                title={
                  <span>
                    <FaUsers />
                    {ancho >= 1280 && <span> DGH</span>}
                  </span>
                }
              >
                <SubMenu
                  key="traspasos"
                  title={
                    <span>
                      <Icons.FolderOpenOutlined />
                      <span className="nav-text">Traspasos</span>
                    </span>
                  }
                >
                  <Menu.Item key="crearTraspaso">
                    <Link to="/rrhh/traspasos/crear">
                      <Icons.TagsOutlined />
                      <span className="nav-text">Acta de Entrega</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="verTraspasos">
                    <Link to="/rrhh/traspasos">
                      <Icons.TableOutlined />
                      <span className="nav-text">Ver Traspasos</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <SubMenu
                  key="Certificaciones"
                  title={
                    <span>
                      <Icons.FolderOpenOutlined />
                      <span className="nav-text">Certificaciones</span>
                    </span>
                  }
                >

                  <Menu.Item key="/rrhh/certificacionesTraspaso">
                    <Link to="/rrhh/certificacionesTraspaso">
                      <Icons.FileTextOutlined />
                      <span className="nav-text">Visado de Certificaciones</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="/rrhh/otrasCertificacionesTraspaso">
                    <Link to="/rrhh/otrasCertificacionesTraspaso">
                      <Icons.FileTextOutlined />
                      <span className="nav-text">Otras Certificaciones</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <SubMenu
                  key="licencias"
                  title={
                    <span>
                      <Icons.FolderOpenOutlined />
                      <span className="nav-text">Licencias</span>
                    </span>
                  }
                >
                  <Menu.Item key="pedirLicencia">
                    <Link to="/rrhh/licencias/crear">
                      <Icons.FileTextOutlined />
                      <span className="nav-text">Pedir Licencia</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="verLicencias">
                    <Link to="/rrhh/licencias/">
                      <Icons.TableOutlined />
                      <span className="nav-text">Ver Licencias</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <SubMenu
                  key="novedades"
                  title={
                    <span>
                      <Icons.FolderOpenOutlined />
                      <span className="nav-text">Novedades</span>
                    </span>
                  }
                >
                  {(usuario.rol === 'FUNCIONARIO' ||
                    usuario.rol === 'DGJP_DIRECTOR' ||
                    usuario.rol === 'DGJP_EMPLEADO' ||
                    usuario.rol === 'SUPERVISOR' ||
                    usuario.rol === 'ADMINISTRADOR') && (
                    <Menu.Item key="cargarNovedad">
                      <Link to="/rrhh/novedades/crear">
                        <Icons.FileTextOutlined />
                        <span className="nav-text">Cargar Novedad</span>
                      </Link>
                    </Menu.Item>
                  )}

                  <Menu.Item key="verNovedades">
                    <Link to="/rrhh/novedades/">
                      <Icons.TableOutlined />
                      <span className="nav-text">Ver Novedades</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <SubMenu
                  key="reportesDGH"
                  title={
                    <span>
                      <Icons.FolderOpenOutlined />
                      <span className="nav-text">Reportes DGH</span>
                    </span>
                  }
                >
                  <Menu.Item key="pedirLicencia">
                    <Link to="/rrhh/reportes/traspasos">
                      <Icons.TableOutlined />
                      <span className="nav-text">Ver Traspasos</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="verLicencias">
                    <Link to="/rrhh/reportes/licencias">
                      <Icons.TableOutlined />
                      <span className="nav-text">Ver Licencias</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>
              </SubMenu>

              {usuario
                ? (usuario.rol == 'SUPERVISOR' ||
                    usuario.rol == 'CONFIGURACION' ||
                    usuario.rol == 'DGJP_DIRECTOR' ||
                    usuario.rol == 'DGJP_EMPLEADO') && (
                    <SubMenu
                      key="administracion"
                      title={
                        <span>
                          <FaUnlockAlt />
                          {ancho >= 1280 && <span> Panel Admin</span>}
                        </span>
                      }
                    >
                      {/* <Menu.Item key="administracion/personas">
              <Link to="/admin/personas">
                <Icon type="team" />Personas
              </Link>
            </Menu.Item> */}

                      <SubMenu
                        key="usuarios"
                        title={
                          <span>
                            <Icons.FolderOpenOutlined />
                            <span className="nav-text">Usuarios</span>
                          </span>
                        }
                      >
                        <Menu.Item key="administracion/usuarios">
                          <Link to="/admin/usuarios">
                            <Icons.TeamOutlined />
                            <span className="nav-text">Listar Usuarios</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="administracion/usuarios/crear">
                          <Link to="/admin/usuarios/crear">
                            <Icons.TeamOutlined />
                            <span className="nav-text">Crear Usuario</span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>

                      <SubMenu
                        key="organismos"
                        title={
                          <span>
                            <Icons.HomeOutlined />
                            <span className="nav-text">Organismos</span>
                          </span>
                        }
                      >
                        {usuario.rol == 'SUPERVISOR' && (
                          <Menu.Item key="crear">
                            <Link to="/admin/organismos/crear">
                              <Icons.HomeOutlined />
                              <span className="nav-text">Crear Organismo</span>
                            </Link>
                          </Menu.Item>
                        )}
                        <Menu.Item key="listar">
                          <Link to="/admin/organismos">
                            <Icons.HomeOutlined />
                            <span className="nav-text">Listar Organismos</span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>

                      <SubMenu
                        key="modelo_notas"
                        title={
                          <span>
                            <Icons.FolderOpenOutlined />
                            <span className="nav-text">Modelos Notas</span>
                          </span>
                        }
                      >
                        <Menu.Item key="crear">
                          <Link to="/admin/editor/nueva">
                            <Icons.FileOutlined />
                            <span className="nav-text">Crear</span>
                          </Link>
                        </Menu.Item>

                        {/* <Menu.Item key="subir">
                  <Link to="/admin/editor/subir">
                    <Icon type="search" />Subir
                  </Link>
                </Menu.Item> */}

                        <Menu.Item key="listar">
                          <Link to="/admin/editor/listar">
                            <Icons.SearchOutlined />
                            <span className="nav-text">Listar</span>
                          </Link>
                        </Menu.Item>
                        {/* <Menu.Item key="buscar">
              <Link to="/buscar">Buscar</Link>
            </Menu.Item> */}
                      </SubMenu>

                      <SubMenu
                        key="categorias"
                        title={
                          <span>
                            <Icons.FolderOpenOutlined />
                            <span className="nav-text">Categorias</span>
                          </span>
                        }
                      >
                        <Menu.Item key="crear">
                          <Link to="/admin/otros/categorias/crear">
                            <Icons.FileOutlined />
                            <span className="nav-text">Crear Categoria</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="listar">
                          <Link to="/admin/otros/categorias">
                            <Icons.SearchOutlined />
                            <span className="nav-text">Listar Categorias</span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>

                      <SubMenu
                        key="medidas"
                        title={
                          <span>
                            <Icons.FolderOpenOutlined />
                            <span className="nav-text">Medidas</span>
                          </span>
                        }
                      >
                        <Menu.Item key="crearMedida">
                          <Link to="/admin/otros/medidas/crear">
                            <Icons.FileOutlined />
                            <span className="nav-text">Crear Medida</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="listarMedidas">
                          <Link to="/admin/otros/medidas">
                            <Icons.SearchOutlined />
                            <span className="nav-text">Listar Medidas</span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>

                      <SubMenu
                        key="clasificadoresEstadisticos"
                        title={
                          <span>
                            <Icons.FolderOpenOutlined />
                            <span className="nav-text">
                              Clasificadores Estadisticos
                            </span>
                          </span>
                        }
                      >
                        <Menu.Item key="crear">
                          <Link to="/admin/otros/clasificadoresEstadisticos/crear">
                            <Icons.FileOutlined />
                            <span className="nav-text">Crear Clasificador</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="listar">
                          <Link to="/admin/otros/clasificadoresEstadisticos">
                            <Icons.SearchOutlined />
                            <span className="nav-text">
                              Listar Clasificadores
                            </span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>

                      <SubMenu
                        key="articulos"
                        title={
                          <span>
                            <Icons.FolderOpenOutlined />
                            <span className="nav-text">
                              Articulos del Codigo
                            </span>
                          </span>
                        }
                      >
                        <Menu.Item key="crear">
                          <Link to="/admin/otros/articulos/crear">
                            <Icons.FileOutlined />
                            <span className="nav-text">Crear Articulo</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="listar">
                          <Link to="/admin/otros/articulos">
                            <Icons.SearchOutlined />
                            <span className="nav-text">Listar Articulos</span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>

                      <SubMenu
                        key="talonarios"
                        title={
                          <span>
                            <Icons.FolderOpenOutlined />
                            <span className="nav-text">Talonarios</span>
                          </span>
                        }
                      >
                        <Menu.Item key="crear">
                          <Link to="/admin/otros/talonarios/crear">
                            <Icons.FileOutlined />
                            <span className="nav-text">Crear Talonario</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="listar">
                          <Link to="/admin/otros/talonarios">
                            <Icons.SearchOutlined />
                            <span className="nav-text">Listar Talonarios</span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>

                      <SubMenu
                        key="tipo_sello"
                        title={
                          <span>
                            <Icons.FolderOpenOutlined />
                            <span className="nav-text">Tasas</span>
                          </span>
                        }
                      >
                        <Menu.Item key="crear">
                          <Link to="/admin/otros/tipo_sello/crear">
                            <Icons.FileOutlined />
                            <span className="nav-text">Crear Tipo de Tasa</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="listar">
                          <Link to="/admin/otros/tipo_sello">
                            <Icons.SearchOutlined />
                            <span className="nav-text">
                              Listar Tipos de Tasas
                            </span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>

                      <SubMenu
                        key="tipo_certificacion"
                        title={
                          <span>
                            <Icons.FolderOpenOutlined />
                            <span className="nav-text">Certificaciones</span>
                          </span>
                        }
                      >
                        <Menu.Item key="crear">
                          <Link to="/admin/otros/tipo_certificacion/crear">
                            <Icons.FileOutlined />
                            <span className="nav-text">
                              Crear Tipo de Certificacion
                            </span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="listar">
                          <Link to="/admin/otros/tipo_certificacion">
                            <Icons.SearchOutlined />
                            <span className="nav-text">
                              Listar Tipos de Certificacion
                            </span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>

                      <SubMenu
                        key="tipo_atencion"
                        title={
                          <span>
                            <Icons.FolderOpenOutlined />
                            <span className="nav-text">Atenciones</span>
                          </span>
                        }
                      >
                        <Menu.Item key="crear">
                          <Link to="/admin/otros/tipo_atencion/crear">
                            <Icons.FileOutlined />
                            <span className="nav-text">
                              Crear Tipo de Atencion
                            </span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="listar">
                          <Link to="/admin/otros/tipo_atencion">
                            <Icons.SearchOutlined />
                            <span className="nav-text">
                              Listar Tipos de Atencion
                            </span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>

                      <SubMenu
                        key="depositos"
                        title={
                          <span>
                            <Icons.FolderOpenOutlined />
                            <span className="nav-text">Depositos</span>
                          </span>
                        }
                      >
                        <Menu.Item key="depositos/listar">
                          <Link to="/admin/depositos">
                            <Icons.SearchOutlined />
                            <span className="nav-text">Listar Depositos</span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>
                      <SubMenu
                        key="Tipo Expedientes"
                        title={
                          <span>
                            <Icons.FolderOpenOutlined />
                            <span className="nav-text">Tipo Expedientes</span>
                          </span>
                        }
                      >
                        <Menu.Item key="crearTipoExpedientes">
                          <Link to="/contravenciones/tipoExpedientes/nuevo">
                            <Icons.SearchOutlined />
                            <span className="nav-text">
                              Crear Tipo Expediente
                            </span>
                          </Link>
                        </Menu.Item>

                        <Menu.Item key="listarTipoExpedientes">
                          <Link to="/contravenciones/tipoExpedientes">
                            <Icons.SearchOutlined />
                            <span className="nav-text">
                              Listar Tipos Expedientes
                            </span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>
                    </SubMenu>
                  )
                : null}

              <SubMenu
                key="estadistica"
                title={
                  <span>
                    <FaUnlockAlt />
                    {ancho >= 1280 && <span> Estadistica</span>}
                  </span>
                }
              >
                {usuario
                  ? (usuario.rol === 'SUPERVISOR' ||
                      usuario.rol === 'ESTADISTICA' ||
                      usuario.rol === 'DGJP_DIRECTOR') && (
                      <Menu.Item key="planillaEstadistica">
                        <Link to={`/estadistica/planilla`}>
                          Planilla Estadistica
                        </Link>
                      </Menu.Item>
                    )
                  : null}
              </SubMenu>

              <SubMenu
                key="documentos"
                title={
                  <span>
                    <FaFileAlt />
                    {ancho >= 1280 && <span> Documentos</span>}
                  </span>
                }
              >
                {usuario
                  ? (usuario.rol == 'SUPERVISOR' ||
                      usuario.rol == 'DGJP_DIRECTOR' ||
                      usuario.rol == 'DGJP_EMPLEADO') && (
                      <Menu.Item key="agregarDocumento">
                        <Link to={'/documentos/agregar'}>
                          Agregar documento
                        </Link>
                      </Menu.Item>
                    )
                  : null}
                <Menu.Item key="verDocumentos">
                  <Link to={'/documentos/listar'}>Ver Documentos</Link>
                </Menu.Item>
              </SubMenu>

              <SubMenu
                key="usuario"
                style={{ float: 'right' }}
                title={
                  <span>
                    <FaUser />
                    {ancho >= 1280 && <span> {data.getUsuario.username}</span>}
                  </span>
                }
              >
                {usuario
                  ? (usuario.rol == 'SUPERVISOR' ||
                      usuario.rol == 'DGJP_DIRECTOR') && (
                      <Menu.Item key="editarme">
                        <Link to={`/admin/usuarios/${usuario._id}`}>
                          Editarme
                        </Link>
                      </Menu.Item>
                    )
                  : null}
                <Menu.Item key="salir">
                  <a onClick={() => this.logout()}>Salir</a>
                </Menu.Item>
              </SubMenu>

              <SubMenu
                key="tag"
                style={{ float: 'right' }}
                title={
                  <Tag color="white" style={{ color: 'rgb(2, 15, 31)' }}>
                    {usuario && usuario.organismo
                      ? usuario.organismo.nombre
                      : 'SIN ORGANISMO'}
                  </Tag>
                }
              />

          <Menu.Item key="linkBusFederal">
            <a href={urlBEBusFed} target="_blank" rel="noopener noreferrer">
              <Icons.DoubleRightOutlined />
              <span className="nav-text">Ir a Bus Fedral Ingreso</span>
            </a>
          </Menu.Item>

              {/*<Divider type="vertical" />*/}

              {/* <SubMenu
            style={{ float: 'right' }}
            key="usuario"
            title={
              <span><Icon type="user" /><span>Esteban</span></span>}
          >
            <Menu.Item key="salir">
              <Link to="/logout">Salir</Link>
            </Menu.Item>
          </SubMenu> */}
            </>
            // >>>>>>>>>AQUI TERMINA EL MENU PARA USUARIOS SIJUP<<<<<<<<<
          )}
        </Menu>
      </div>
    );
  }
}

const mapDispatchToProps = {
  logout
};

MenuPropio.propTypes = {
  data: PropTypes.object,
};

export default compose(
  graphql(getUsuario),
  connect(null, { logout })
)(MenuPropio);
